import { render, staticRenderFns } from "./InterfaceTableBuilder.vue?vue&type=template&id=5339e92e&scoped=true"
import script from "./InterfaceTableBuilder.vue?vue&type=script&lang=js"
export * from "./InterfaceTableBuilder.vue?vue&type=script&lang=js"
import style0 from "./InterfaceTableBuilder.vue?vue&type=style&index=0&id=5339e92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5339e92e",
  null
  
)

export default component.exports